var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"rounded-12 section-card cursor-pointer hover-card",attrs:{"flat":"","outlined":""}},[_c('v-card-text',{staticClass:"px-6"},[_c('p',{staticClass:"caption mb-0"},[_vm._v("Journey name")]),_c('v-text-field',{attrs:{"dense":"","outlined":"","hide-details":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }